/* QOWAA FIT — PDP behaviors (page produit universelle · 14 blocs)
   Recréé en vanilla JS depuis le prototype React « PDP QOWAA FIT.html ».
   Galerie + lightbox · accordéons · sélection variantes (taille/couleur) ·
   ajout panier AJAX + mini-cart + toast · sticky CTA mobile · date de livraison.
   Aucune dépendance. Initialisé par section ; supporte plusieurs PDP par page. */
(function () {
  'use strict';

  var DESK = 1000;
  function isDesktop() { return window.innerWidth >= DESK; }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function moneyNum(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function money(cents) { return moneyNum(cents) + ' €'; }
  // € enveloppé en police de corps (Michroma le rend mal) — pour les zones en font display
  function moneyHtml(cents) { return moneyNum(cents) + ' <span class="qw-cur">€</span>'; }

  // ───────────────────────────────────────────────
  // GALERIE + LIGHTBOX
  // ───────────────────────────────────────────────
  function initGallery(root) {
    var gallery = $('[data-pdp-gallery]', root);
    if (!gallery) return;
    var track = $('.gallery__track', gallery);
    var slides = $all('.gallery__slide', track);
    var thumbs = $all('[data-pdp-thumb]', gallery);
    var dots = $all('.gallery__dot', gallery);
    var counter = $('[data-pdp-counter]', gallery);
    var total = slides.length;
    var idx = 0;
    var startX = null, deltaX = 0;

    function pad(n) { return ('0' + n).slice(-2); }
    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }
    function go(i) { idx = Math.max(0, Math.min(total - 1, i)); render(); }

    thumbs.forEach(function (t) { t.addEventListener('click', function () { var vi = thumbs.indexOf(t); if (vi >= 0) go(vi); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    // Filtre par couleur : n'affiche que les médias de la couleur choisie (fallback : tout)
    var qwAllSlides = slides.slice();
    var qwAllThumbs = thumbs.slice();
    gallery.__qwFilterColor = function (color) {
      var match = qwAllSlides.filter(function (s) { return (s.getAttribute('data-qw-mcolor') || '') === color; });
      var use = (color && match.length) ? match : qwAllSlides;
      qwAllSlides.forEach(function (s, i) {
        var show = use.indexOf(s) >= 0;
        s.style.display = show ? '' : 'none';
        if (qwAllThumbs[i]) qwAllThumbs[i].style.display = show ? '' : 'none';
      });
      slides = use;
      thumbs = qwAllThumbs.filter(function (t) { return t.style.display !== 'none'; });
      total = slides.length;
      dots.forEach(function (d, i) { d.style.display = i < total ? '' : 'none'; });
      idx = 0; render();
    };
    var qwAct = $('.colors .color.is-active', root);
    if (qwAct) gallery.__qwFilterColor(qwAct.getAttribute('data-value'));

    var main = $('.gallery__main', gallery);
    main.addEventListener('touchstart', function (e) {
      if (isDesktop()) return;
      startX = e.touches[0].clientX; deltaX = 0;
      track.style.transition = 'none';
    }, { passive: true });
    main.addEventListener('touchmove', function (e) {
      if (isDesktop() || startX == null) return;
      deltaX = e.touches[0].clientX - startX;
      var pct = (deltaX / main.offsetWidth) * 100;
      track.style.transform = 'translateX(calc(' + (-idx * 100) + '% + ' + pct + '%))';
    }, { passive: true });
    main.addEventListener('touchend', function () {
      if (isDesktop() || startX == null) return;
      track.style.transition = '';
      var th = 40;
      if (deltaX < -th) go(idx + 1);
      else if (deltaX > th) go(idx - 1);
      else render();
      startX = null; deltaX = 0;
    });

    // Lightbox
    var lb = $('[data-pdp-lightbox]', root);
    if (lb) {
      var lbStage = $('[data-pdp-lightbox-stage]', lb);
      var lbCounter = $('[data-pdp-lightbox-counter]', lb);
      var lbIdx = 0;
      function lbRender() {
        var src = slides[lbIdx] ? slides[lbIdx].getAttribute('data-zoom-src') : '';
        lbStage.innerHTML = src
          ? '<img src="' + src + '" alt="">'
          : '<span class="gallery__lbl">' + (slides[lbIdx] ? (slides[lbIdx].getAttribute('data-label') || '') : '') + '</span>';
        if (lbCounter) lbCounter.textContent = pad(lbIdx + 1) + ' / ' + pad(total) + ' · ZOOM';
      }
      function lbOpen(i) { lbIdx = i; lbRender(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function lbClose() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
      // Click sur l'image principale (hors bouton play vidéo) → zoom
      main.addEventListener('click', function (e) {
        if (e.target.closest('[data-pdp-video-play]')) return;
        lbOpen(idx);
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbStage || e.target.closest('[data-pdp-lightbox-close]')) lbClose(); });
      var prev = $('[data-pdp-lightbox-prev]', lb), next = $('[data-pdp-lightbox-next]', lb);
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); lbIdx = Math.max(0, lbIdx - 1); lbRender(); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); lbIdx = Math.min(total - 1, lbIdx + 1); lbRender(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowRight') { lbIdx = Math.min(total - 1, lbIdx + 1); lbRender(); }
        if (e.key === 'ArrowLeft') { lbIdx = Math.max(0, lbIdx - 1); lbRender(); }
      });
    }

    // Lecture vidéo inline (slide vidéo)
    $all('[data-pdp-video-play]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var slide = btn.closest('.gallery__slide');
        var v = slide && slide.querySelector('video');
        if (v) {
          slide.querySelectorAll('.gallery__slide-overlay,[data-pdp-video-play],.gallery__lbl').forEach(function (el) { el.style.display = 'none'; });
          v.setAttribute('controls', '');
          v.play().catch(function () {});
        }
      });
    });

    render();
  }

  // ───────────────────────────────────────────────
  // ACCORDÉONS (Matière, Guide des tailles, FAQ)
  // ───────────────────────────────────────────────
  function initAccordions(root) {
    $all('[data-pdp-acc-group]', root).forEach(function (group) {
      var single = group.getAttribute('data-pdp-acc-group') === 'single';
      $all('.acc', group).forEach(function (acc) {
        var btn = $('.acc__btn', acc);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = acc.classList.contains('is-open');
          if (single) $all('.acc', group).forEach(function (a) { a.classList.remove('is-open'); a.querySelector('.acc__btn').setAttribute('aria-expanded', 'false'); });
          acc.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    });

  }

  // ───────────────────────────────────────────────
  // MODALE — Guide des tailles (popup au clic)
  // ───────────────────────────────────────────────
  function initSizeModal(root) {
    var modal = $('[data-pdp-size-modal]', root);
    if (!modal) return;
    function open() { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    $all('[data-pdp-size-guide-link]', root).forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $all('[data-pdp-size-modal-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  // ───────────────────────────────────────────────
  // VARIANTES — sélection taille / couleur
  // ───────────────────────────────────────────────
  function initVariants(root) {
    var dataEl = $('[data-pdp-variants]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var lowThreshold = parseInt(root.getAttribute('data-low-threshold') || '5', 10);
    var form = $('[data-pdp-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var addBtn = $('[data-pdp-add]', root);
    var stickyBtn = $('[data-pdp-sticky-add]', root);
    var priceEl = $('[data-pdp-price]', root);
    var oldPriceEl = $('[data-pdp-price-old]', root);
    var stickyPrice = $('[data-pdp-sticky-price]', root);
    var stickyName = $('[data-pdp-sticky-name]', root);
    var lowEl = $('[data-pdp-low]', root);
    var notify = $('[data-pdp-notify]', root);
    var optionCount = parseInt(root.getAttribute('data-option-count') || '1', 10);

    // Sélection courante (option1..3)
    var selected = [null, null, null];

    function matchVariant() {
      if (optionCount === 0) return variants.find(function (v) { return v.available; }) || variants[0];
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (selected[i] != null && v['option' + (i + 1)] !== selected[i]) return false;
          if (selected[i] == null) return false;
        }
        return true;
      });
    }
    function variantsFor(optionIndex, value, otherSelected) {
      // variantes qui matchent `value` sur l'option donnée + les autres options déjà choisies
      return variants.filter(function (v) {
        if (v['option' + (optionIndex + 1)] !== value) return false;
        for (var i = 0; i < optionCount; i++) {
          if (i === optionIndex) continue;
          if (otherSelected[i] != null && v['option' + (i + 1)] !== otherSelected[i]) return false;
        }
        return true;
      });
    }
    function valueAvailable(optionIndex, value) {
      return variantsFor(optionIndex, value, selected).some(function (v) { return v.available; });
    }

    function refreshAvailability() {
      $all('[data-pdp-option]', root).forEach(function (sel) {
        var oi = parseInt(sel.getAttribute('data-pdp-option'), 10);
        $all('[data-value]', sel).forEach(function (btn) {
          var avail = valueAvailable(oi, btn.getAttribute('data-value'));
          btn.classList.toggle('is-oos', !avail);
        });
      });
    }

    function setCTAState(variant) {
      var ready = !!variant;
      var available = ready && variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.classList.toggle('is-disabled', !available);
        var label = $('[data-pdp-add-label]', addBtn);
        if (label) {
          label.innerHTML = !ready ? addBtn.getAttribute('data-pick-label')
            : available ? (addBtn.getAttribute('data-add-label') + ' · ' + moneyHtml(variant.price))
            : 'Indisponible';
        }
      }
      if (stickyBtn) {
        stickyBtn.textContent = !ready ? stickyBtn.getAttribute('data-pick-label')
          : available ? stickyBtn.getAttribute('data-add-label')
          : 'Indisponible';
        // is-disabled tant qu'aucune variante dispo n'est complètement choisie
        stickyBtn.classList.toggle('is-disabled', !available);
      }
    }

    function updatePrice(variant) {
      if (!variant) return;
      if (priceEl) priceEl.innerHTML = moneyHtml(variant.price);
      if (stickyPrice) stickyPrice.innerHTML = moneyHtml(variant.price);
      if (oldPriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          oldPriceEl.innerHTML = moneyHtml(variant.compare_at_price);
          oldPriceEl.hidden = false;
        } else { oldPriceEl.hidden = true; }
      }
    }

    function updateLowStock(variant) {
      if (!lowEl) return;
      var qty = variant && typeof variant.inventory_quantity === 'number' && variant.inventory_managed
        ? variant.inventory_quantity : null;
      if (variant && variant.available && qty != null && qty > 0 && qty <= lowThreshold) {
        var strong = $('[data-pdp-low-qty]', lowEl);
        if (strong) strong.textContent = qty;
        var sz = $('[data-pdp-low-size]', lowEl);
        if (sz) sz.textContent = selected[sizeOptionIndex] || variant.title;
        lowEl.hidden = false;
      } else {
        lowEl.hidden = true;
      }
    }

    // index de l'option « taille » (pour les messages) — détecté via data-attr
    var sizeOptionIndex = parseInt(root.getAttribute('data-size-option') || '0', 10);

    function onChange() {
      var variant = matchVariant();
      if (idInput && variant) idInput.value = variant.id;
      refreshAvailability();
      setCTAState(variant);
      updatePrice(variant);
      updateLowStock(variant);
      if (stickyName) {
        var parts = selected.slice(0, optionCount).filter(Boolean);
        stickyName.textContent = root.getAttribute('data-product-title') + (parts.length ? ' · ' + parts.join(' / ') : '');
      }
      // ferme le notify si la variante choisie est dispo
      if (notify && variant && variant.available) notify.hidden = true;
    }

    // Clic sur une valeur d'option
    $all('[data-pdp-option]', root).forEach(function (sel) {
      var oi = parseInt(sel.getAttribute('data-pdp-option'), 10);
      var valEl = $('[data-pdp-option-value]', sel);
      $all('[data-value]', sel).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-value');
          var oos = btn.classList.contains('is-oos');
          if (oos) {
            // taille indispo → ouvre « Préviens-moi »
            selected[oi] = value;
            $all('[data-value]', sel).forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            if (valEl) valEl.textContent = btn.getAttribute('data-value-label') || value;
            openNotify(value);
            onChange();
            return;
          }
          selected[oi] = value;
          $all('[data-value]', sel).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (valEl) valEl.textContent = btn.getAttribute('data-value-label') || value;
          if (sel.querySelector('.colors')) {
            var qwG = $('[data-pdp-gallery]', root);
            if (qwG && qwG.__qwFilterColor) qwG.__qwFilterColor(value);
          }
          onChange();
        });
      });
    });

    // Préselection : si une seule variante OU preselect activé
    function preselect() {
      // si une option n'a qu'une valeur, on la choisit d'office
      $all('[data-pdp-option]', root).forEach(function (sel) {
        var oi = parseInt(sel.getAttribute('data-pdp-option'), 10);
        var btns = $all('[data-value]', sel);
        var preselectThis = sel.getAttribute('data-preselect') === 'true' || btns.length === 1;
        if (preselectThis) {
          var first = btns.find(function (b) { return !b.classList.contains('is-oos'); }) || btns[0];
          if (first) first.click();
        }
      });
    }

    // Notify-me (rupture)
    function openNotify(value) {
      if (!notify) return;
      $all('[data-pdp-notify-size]', notify).forEach(function (el) { el.textContent = value; });
      notify.hidden = false;
      var body = $('[data-pdp-notify-body]', notify);
      var success = $('[data-pdp-notify-success]', notify);
      if (body) body.hidden = false;
      if (success) success.hidden = true;
    }
    if (notify) {
      var nClose = $('[data-pdp-notify-close]', notify);
      if (nClose) nClose.addEventListener('click', function () { notify.hidden = true; });
      // NOTE: capture front-end uniquement. Brancher une vraie app « back-in-stock »
      // (Klaviyo / Shopify Notify) sur cet event pour la notification réelle.
      function submitNotify() {
        var input = $('[data-pdp-notify-input]', notify);
        if (input && !input.checkValidity()) { input.reportValidity(); return; }
        var body = $('[data-pdp-notify-body]', notify);
        var success = $('[data-pdp-notify-success]', notify);
        if (body) body.hidden = true;
        if (success) success.hidden = false;
        setTimeout(function () { notify.hidden = true; }, 3000);
      }
      var nSubmit = $('[data-pdp-notify-submit]', notify);
      if (nSubmit) nSubmit.addEventListener('click', submitNotify);
      var nInput = $('[data-pdp-notify-input]', notify);
      if (nInput) nInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitNotify(); } });
    }

    refreshAvailability();
    if (optionCount === 0) {
      // produit à variante unique (pas de sélecteur) → prêt à ajouter
      onChange();
    } else {
      setCTAState(null);
      preselect();
    }
  }

  // ───────────────────────────────────────────────
  // QUANTITÉ
  // ───────────────────────────────────────────────
  function initQty(root) {
    var wrap = $('[data-pdp-qty]', root);
    if (!wrap) return;
    var input = $('input', wrap) || $('[data-pdp-qty-input]', wrap);
    var val = $('[data-pdp-qty-val]', wrap);
    var minus = $('[data-pdp-qty-minus]', wrap);
    var plus = $('[data-pdp-qty-plus]', wrap);
    var q = 1;
    function render() {
      if (val) val.textContent = q;
      if (input) input.value = q;
      if (minus) minus.disabled = q <= 1;
    }
    if (minus) minus.addEventListener('click', function () { q = Math.max(1, q - 1); render(); });
    if (plus) plus.addEventListener('click', function () { q = Math.min(10, q + 1); render(); });
    render();
  }

  // ───────────────────────────────────────────────
  // PANIER AJAX + MINI-CART + TOAST
  // ───────────────────────────────────────────────
  function initCart(root) {
    var form = $('[data-pdp-form]', root);
    var addBtn = $('[data-pdp-add]', root);
    var stickyBtn = $('[data-pdp-sticky-add]', root);
    var drawer = $('[data-pdp-cart]', root);
    var overlay = $('[data-pdp-cart-overlay]', root);
    var toast = $('[data-pdp-toast]', root);
    if (!form) return;

    function openDrawer() { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; if (typeof closeSheet === 'function') closeSheet(); }

    $all('[data-pdp-cart-close]', root).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);

    function showToast(msg) {
      if (!toast) return;
      var span = $('[data-pdp-toast-msg]', toast);
      if (span) span.textContent = msg;
      toast.classList.add('is-visible');
      setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
    }

    function renderCart(cart, newKey) {
      if (!drawer) return;
      var body = $('[data-pdp-cart-body]', drawer);
      var foot = $('[data-pdp-cart-foot]', drawer);
      var countEl = $('[data-pdp-cart-count]', drawer);
      if (countEl) countEl.textContent = cart.item_count;
      renderCross(cart);
      var tiersC = drawer.querySelector('[data-qw-tiers]');
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart__empty">Ton panier est vide.</div>';
        if (foot) foot.hidden = true;
        if (tiersC) tiersC.style.display = 'none';
        return;
      }
      if (tiersC) { tiersC.style.display = ''; if (window.QowaaTiers) window.QowaaTiers.render(tiersC, cart.total_price); }
      body.innerHTML = cart.items.map(function (it) {
        var isNew = newKey && it.key === newKey;
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var isGift = !!(it.properties && it.properties._qw_gift);
        var controls = isGift
          ? '<span class="cart-item__giftlbl">Cadeau offert</span>'
          : '<div class="cart-item__qtybar">' +
              '<button type="button" class="cart-item__qbtn" data-pdp-line-minus aria-label="Diminuer">−</button>' +
              '<span class="cart-item__qval">' + it.quantity + '</span>' +
              '<button type="button" class="cart-item__qbtn" data-pdp-line-plus aria-label="Augmenter">+</button>' +
              '<button type="button" class="cart-item__rm" data-pdp-line-remove aria-label="Supprimer">Supprimer</button>' +
            '</div>';
        return '<div class="cart-item' + (isNew ? ' is-new' : '') + '" data-line-key="' + it.key + '">' +
          '<div class="cart-item__media">' + img + '</div>' +
          '<div class="cart-item__info">' +
            '<span class="cart-item__name">' + it.product_title + '</span>' +
            (variant ? '<span class="cart-item__variant">' + variant + '</span>' : '') +
            controls +
          '</div>' +
          '<span class="cart-item__price">' + (isGift ? 'Offert' : money(it.final_line_price)) + '</span>' +
        '</div>';
      }).join('');
      if (foot) {
        foot.hidden = false;
        var totalEl = $('[data-pdp-cart-total]', foot);
        if (totalEl) totalEl.textContent = money(cart.total_price);
        var shipEl = $('[data-pdp-cart-shipping]', foot);
        if (shipEl) {
          var threshold = 7900;
          shipEl.textContent = cart.total_price >= threshold
            ? '✓ Livraison offerte'
            : 'Plus que ' + money(threshold - cart.total_price) + ' pour la livraison offerte';
        }
      }
      setTimeout(function () { var el = body.querySelector('.is-new'); if (el) el.classList.remove('is-new'); }, 1400);
    }

    function updateHeaderCount(count) {
      $all('.header__badge').forEach(function (b) { b.textContent = count; b.style.display = ''; });
    }

    // Modif quantité / suppression d'une ligne du panier (depuis le drawer)
    var cartBusy = false;
    function changeLine(key, qty) {
      if (cartBusy || !key) return;
      cartBusy = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart, null); updateHeaderCount(cart.item_count); })
        .catch(function () {})
        .finally(function () { cartBusy = false; });
    }
    var cartBodyEl = drawer ? $('[data-pdp-cart-body]', drawer) : null;
    if (cartBodyEl) cartBodyEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]'); if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qv = line.querySelector('.cart-item__qval');
      var cur = qv ? (parseInt(qv.textContent, 10) || 1) : 1;
      if (e.target.closest('[data-pdp-line-plus]')) { changeLine(key, cur + 1); return; }
      if (e.target.closest('[data-pdp-line-minus]')) { changeLine(key, cur - 1); return; } // 1→0 = suppression
      if (e.target.closest('[data-pdp-line-remove]')) { changeLine(key, 0); return; }
    });

    // Section « Complète ta tenue » (suggestions) : masque les produits déjà au panier
    var crossWrap = drawer ? $('[data-pdp-cart-cross]', drawer) : null;
    function renderCross(cart) {
      if (!crossWrap) return;
      // Rail « Complète ta tenue » = TOUS les articles (on ne masque plus ceux du panier) → plein + scrollable.
      crossWrap.hidden = !(cart && cart.item_count > 0);
    }
    var sizeSheet = drawer ? drawer.querySelector('[data-cart-sizesheet]') : null;
    var sheetRow = sizeSheet ? sizeSheet.querySelector('[data-sizesheet-row]') : null;
    var sheetTitle = sizeSheet ? sizeSheet.querySelector('[data-sizesheet-title]') : null;
    function openSheet(card) {
      if (!sizeSheet || !sheetRow || !card) return;
      var src = card.querySelector('[data-cross-sizes]');
      if (!src) return;
      var nameEl = card.querySelector('.cart-cross__name');
      sheetRow.innerHTML = src.innerHTML;
      if (sheetTitle) sheetTitle.textContent = nameEl ? ('Choisis ta taille — ' + nameEl.textContent.trim()) : 'Choisis ta taille';
      sizeSheet.classList.add('is-open');
      sizeSheet.setAttribute('aria-hidden', 'false');
    }
    function closeSheet() {
      if (!sizeSheet) return;
      sizeSheet.classList.remove('is-open');
      sizeSheet.setAttribute('aria-hidden', 'true');
    }
    function crossAdd(el) {
      if (cartBusy) return;
      var vid = el.getAttribute('data-variant-id'); if (!vid) return;
      cartBusy = true; el.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { closeSheet(); renderCart(cart, null); updateHeaderCount(cart.item_count); })
        .catch(function () {})
        .finally(function () { cartBusy = false; el.classList.remove('is-loading'); });
    }
    if (crossWrap) crossWrap.addEventListener('click', function (e) {
      var tog = e.target.closest('[data-cross-toggle]');
      if (tog) { e.preventDefault(); openSheet(tog.closest('.cart-cross')); return; }
      var addEl = e.target.closest('[data-pdp-cross-add]');
      if (addEl) { e.preventDefault(); crossAdd(addEl); return; }
    });
    if (sizeSheet) sizeSheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizesheet-close]')) { closeSheet(); return; }
      var addEl = e.target.closest('[data-cross-add]');
      if (addEl) { e.preventDefault(); crossAdd(addEl); }
    });

    function add() {
      if (addBtn && addBtn.disabled) return;
      var idInput = $('input[name="id"]', form);
      var qtyInput = $('[data-pdp-qty-input]', form) || $('input[name="quantity"]', form);
      var fd = new FormData();
      fd.append('id', idInput ? idInput.value : '');
      fd.append('quantity', qtyInput ? qtyInput.value : 1);
      if (addBtn) addBtn.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { showToast(res.body.description || 'Erreur — réessaie.'); return; }
          var added = res.body;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderCart(cart, added.key);
              updateHeaderCount(cart.item_count);
              showToast('✓ ' + added.product_title + (added.variant_title && added.variant_title !== 'Default Title' ? ' (' + added.variant_title + ')' : '') + ' ajouté');
              setTimeout(openDrawer, 50);
            });
        })
        .catch(function () { showToast('Erreur réseau — réessaie.'); })
        .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    var stickySizes = $('[data-pdp-sticky-sizes]', root);
    function closeStickySizes() { if (stickySizes) stickySizes.hidden = true; }
    // Produit à tailles : le sticky OUVRE TOUJOURS le sélecteur (le client choisit), jamais d'ajout
    // direct d'une taille par défaut. On force le libellé sur « Choisis ta taille ».
    if (stickySizes && stickyBtn) {
      var pickLbl = stickyBtn.getAttribute('data-pick-label') || 'Choisis ta taille';
      stickyBtn.setAttribute('data-add-label', pickLbl);
      stickyBtn.textContent = pickLbl;
      stickyBtn.classList.add('sticky-cta__btn--choose'); // toujours actionnable (ouvre le sélecteur) → reste noir
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (stickySizes) { stickySizes.hidden = !stickySizes.hidden; return; }
      if (stickyBtn.classList.contains('is-disabled')) { onPickSize(root); return; }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'sticky_cta_click', product_handle: root.getAttribute('data-product-handle') || '' });
      }
      add();
    });
    if (stickySizes) stickySizes.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-pdp-sticky-size]');
      if (!chip || chip.disabled) return;
      var val = chip.getAttribute('data-value');
      // sélectionne la taille dans les options principales (synchro), puis ajoute la taille choisie
      var target = null;
      $all('[data-pdp-option][data-size] [data-value]', root).forEach(function (b) { if (b.getAttribute('data-value') === val) target = b; });
      if (target) target.click();
      closeStickySizes();
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'sticky_cta_click', product_handle: root.getAttribute('data-product-handle') || '' });
      }
      add();
    });
    document.addEventListener('click', function (e) {
      if (!stickySizes || stickySizes.hidden) return;
      if (e.target.closest('[data-pdp-sticky]')) return;
      closeStickySizes();
    });
  }

  function onPickSize(root) {
    var sizes = $('[data-pdp-option][data-size="true"]', root) || $('[data-pdp-option]', root);
    if (!sizes) return;
    sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sizes.animate(
      [{ outline: '2px solid var(--qw-warning)', outlineOffset: '4px' }, { outline: '2px solid transparent', outlineOffset: '4px' }],
      { duration: 1200 }
    );
  }

  // ───────────────────────────────────────────────
  // STICKY CTA (mobile + desktop) — déclenché par la sortie du CTA principal
  // ───────────────────────────────────────────────
  function initStickyCTA(root) {
    var sticky = $('[data-pdp-sticky]', root);
    var addBtn = $('[data-pdp-add]', root);
    if (!sticky || !addBtn) return;
    var seen = false;
    function setVisible(v) {
      sticky.classList.toggle('is-visible', v);
      if (v && !seen) {
        seen = true;
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'sticky_cta_view', product_handle: root.getAttribute('data-product-handle') || '' });
        }
      }
    }
    function compute() {
      var r = addBtn.getBoundingClientRect();
      // visible quand le CTA principal est passé au-dessus du viewport, sauf tout en bas (footer)
      var ctaAbove = r.bottom < 0;
      var docBottom = document.body.scrollHeight - (window.scrollY + window.innerHeight);
      setVisible(ctaAbove && docBottom > 120);
    }
    window.addEventListener('scroll', compute, { passive: true });
    window.addEventListener('resize', compute);
    compute();
  }

  // ───────────────────────────────────────────────
  // BLOC 6 — Date de livraison (jours ouvrés)
  // ───────────────────────────────────────────────
  function initDelivery(root) {
    var el = $('[data-pdp-delivery]', root);
    if (!el) return;
    var days = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];
    var months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    function addBiz(date, n) { var d = new Date(date), a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    var now = new Date();
    var s = $('[data-pdp-delivery-start]', el), e = $('[data-pdp-delivery-end]', el);
    if (s) s.textContent = fmt(addBiz(now, 2));
    if (e) e.textContent = fmt(addBiz(now, 4));
  }

  // ───────────────────────────────────────────────
  // ───────────────────────────────────────────────
  // CARROUSEL « Le reste du vestiaire »
  // ───────────────────────────────────────────────
  function initCrossCarousel(root) {
    var rail = $('[data-cross-rail]', root);
    if (!rail) return;
    var prev = $('[data-cross-prev]', root);
    var next = $('[data-cross-next]', root);
    function step() {
      var card = rail.querySelector('.cross-card');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 20;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var scrollable = max > 2;
      if (prev) prev.classList.toggle('is-off', !scrollable || rail.scrollLeft <= 2);
      if (next) next.classList.toggle('is-off', !scrollable || rail.scrollLeft >= max);
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initPdp(root) {
    initGallery(root);
    initAccordions(root);
    initSizeModal(root);
    initVariants(root);
    initQty(root);
    initCart(root);
    initStickyCTA(root);
    initDelivery(root);
    initCrossCarousel(root);
  }

  function boot() { $all('[data-pdp-root]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init dans l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pdp-root]');
    if (root) initPdp(root);
  });
})();
